import { theme } from '@Guidelines/Theme/theme';
import { css } from '@emotion/react';
import type * as React from 'react';
import { Link } from 'react-router-dom';

const linkStyle = css`
	align-self: flex-start;
	font-family: ${theme.fonts.body};
	font-size: ${theme.fontSizes.medium};
	font-weight: ${theme.fontWeights.medium};
	color: ${theme.colors.accent};
`;

type Props = {
	readonly to: string;
	readonly label: string;
	readonly onClick?: (event: React.MouseEvent<HTMLAnchorElement>) => void;
};

/** « ← {label} » above the title of a screen: the way back to the screen it was opened from. */
const BackLink: React.FC<Props> = ({ to, label, onClick }) => {
	return (
		<Link css={linkStyle} to={to} onClick={onClick}>
			← {label}
		</Link>
	);
};

export default BackLink;
